const DEVICE_KINDS = {
  VIDEO: 'videoinput',
  AUDIO: 'audioinput',
  OUTPUT: 'audiooutput'
};

const STORAGE_SUFFIXES = {
  [DEVICE_KINDS.VIDEO]: '_video_dev',
  [DEVICE_KINDS.AUDIO]: '_audio_dev',
  [DEVICE_KINDS.OUTPUT]: '_speaker_dev'
};

const EVENTS = {
  DEVICE_STATUS_CHANGE: 'sn-change-device-status',
  VIDEO_BG_CHANGE: 'sn-change-video-bg',
  SETTINGS_CHANGED: 'sn-live-meeting-settings-changed',
  ROOM_VIEW_ATTACHED: 'SnVideoRoomViewAttached',
  PRESENTATION_CHANGED: 'participants-presentation-changed'
};

const ERROR_MESSAGES = {
  CAMERA_UNAVAILABLE: 'Your camera is currently not available. It might be in use by another application. Close all other video-based applications and then try turning on your camera again.',
  MICROPHONE_UNAVAILABLE: 'Your microphone is currently not available. It might be in use by another application. Close all other audio-based applications and then try turning on your microphone again.'
};

const AUDIO_TRACK_HEAL = {
  MUTE_TIMEOUT_MS: 5000,
  UNMUTE_REBUILD_DELAY_MS: 1000,
  RETRY_DELAY_MS: 15000
};

const RETRY_INFINITE = {retries: "INFINITELY", delay: 200, until: (v) => v};

const shouldSkipForBroadcast = () => {
  if (Drupal.settings.is_broadcast_request) {
    console.warn("is broadcast request page");
    return true;
  }
  return false;
};

export const MediaDevicesButtons = function (nid, enable_camera = true, enable_microphone = true) {
  console.log('MediaDevicesButtons Component: init', {nid, enable_camera, enable_microphone});

  if (shouldSkipForBroadcast()) {
    return;
  }

  const templateHTML = `
<div class="dropdown device-menu">
  <a id="microphoneButton" :title="microphone_tip" class="microphoneButton toolbarButton round-btn video-icon"
   :class="(is_microphone_restoring || is_microphone_processing) ? 'microphoneLoading' : (is_microphone_on ? 'microphoneOn' : 'microphoneOff')"
   @click.throttle.550ms="onMicrophoneBtnClick"
  >
    <i x-show="!is_microphone_processing && !is_microphone_restoring" class="action-icon-fa fa-light" :class="'fa-microphone'+(is_microphone_on ? '':'-slash')" aria-hidden="true"></i>
    <i x-show="is_microphone_processing || is_microphone_restoring" class="action-icon-fa fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
  </a>
  <i class="fa-duotone fa-solid fa-message-exclamation" aria-hidden="true" x-show="microphones?.length === 0 && speakers?.length === 0"></i>
  <a id="microphone-list-trigger" class="device-list dropdown-toggle" aria-expanded="false" x-show="microphones?.length > 0 || speakers?.length > 0" @click="onSettingsClick('audio')">
    <i class="fa-duotone fa-circle-chevron-up fa-rotate-180" aria-hidden="true"></i>
  </a>
</div>
<div class="dropdown device-menu">
  <a id="cameraButton" :title="camera_tip" class="cameraButton toolbarButton round-btn video-icon"
   :class="(is_camera_restoring || is_camera_processing) ? 'cameraLoading' : (is_camera_on ? 'cameraOn' : 'cameraOff')"
   @click.throttle.550ms="onCameraBtnClick"
  >
    <i x-show="!is_camera_processing && !is_camera_restoring" class="action-icon-fa fa-light" :class="'fa-video'+(is_camera_on ? '':'-slash')" aria-hidden="true"></i>
    <i x-show="is_camera_processing || is_camera_restoring" class="action-icon-fa fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
  </a>
  <i class="fa-duotone fa-solid fa-message-exclamation" aria-hidden="true" x-show="cameras?.length === 0"></i>
  <a id="camera-list-trigger" class="device-list dropdown-toggle" aria-expanded="false" x-show="cameras?.length > 0" @click="onSettingsClick('camera')">
    <i class="fa-duotone fa-circle-chevron-up fa-rotate-180" aria-hidden="true"></i>
  </a>
</div>
`;
  const camera_not_available_msg = ERROR_MESSAGES.CAMERA_UNAVAILABLE;
  const cancellationOptions = {
    sdkAssetsPath: '/sites/all/modules/sn_twilio/krisp/v1.0.0',
    vendor: 'krisp'
  };

  const eventListeners = [];
  const cleanupListeners = () => {
    eventListeners.forEach(({target, type, listener, options, isProperty}) => {
      if (isProperty) {
        target[type] = null;
      } else {
        target.removeEventListener(type, listener, options);
      }
    });
    eventListeners.length = 0;
  };
  const addTrackedListener = (target, type, listener, options = false) => {
    target.addEventListener(type, listener, options);
    eventListeners.push({target, type, listener, options});
  };
  const screenshare_track_names = ['screenShare', 'video-composer-presentation', 'audio-composer-presentation'];
  const presentation_track_names = ['video-presentation-video', 'video-presentation-audio'];
  const sid = tryget(() => Toolbox.snExpoLocation.current.current_content.content_id, "") ?? "";
  const storage_prefix = `${Drupal.settings.current_user_name}_${sid}`;
  const post_video_bg_data = async function (type, url, images = []) {
    const form = new FormData();
    form.set("type", type);
    if (url) {
      form.set("img", url);
    }
    if (images?.length > 0) {
      form.set("imgs", JSON.stringify(images));
    }
    await fetch(`/twilio/video/bg?gid=${_current_expoid()}`, {method: 'POST', body: form});
  };
  const load_cancellation_models = async function () {
    // return Twilio.Video.createLocalAudioTrack({
    //   'noiseCancellationOptions': cancellationOptions
    // }).then((track) => {
    //   track.stop();
    // }).catch((e) => {
    //   console.log(e);
    // });
    return fetch(`${_base_url()}${cancellationOptions.sdkAssetsPath}/weights/model_32.kw`).catch((e) => {
      console.log(e);
    });
  };
  const get_deviceId_from_storage = function (kind, devices = []) {
    if (!kind || !devices) {
      return '';
    }
    const ids = devices.map(d => d.deviceId);
    const suffix = STORAGE_SUFFIXES[kind] ?? '';
    const storage_key = localStorage.getItem(`${storage_prefix}${suffix}`);
    return ids.includes(storage_key) ? storage_key : (devices[0]?.deviceId ?? '');
  };
  const check_device_permission = async function (name = '') {
    let names = ['camera', 'microphone'];
    if (names.includes(name)) {
      names = [name];
    }
    const permissions = {};
    for (const name of names) {
      try {
        permissions[name] = await navigator.permissions.query({name: name});
      } catch (e) {
        console.error(e);
      }
    }
    return permissions;
  };
  const request_device_permission = async function (constraints = {video: true, audio: true}, stop_tracks = true) {
    console.log('request_device_permission1', {constraints, stop_tracks});
    const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    if (stop_tracks) {
      (mediaStream?.getTracks() ?? []).forEach(track => track.stop());
    }
    console.log('request_device_permission2', {
      constraints,
      stop_tracks,
      tracks: (mediaStream?.getTracks() ?? []).map(t => t.label)
    });
  };
  const show_popup = function (name, kind = 'microphone / camera') {
    let title = '';
    let clazz = '';
    let msg = '';
    if (name === 'settings') {
      title = `Permission Required`;
      clazz = 'devices_permission_settings_popup';
      msg = `
<div class="msg">Check your browser and system settings to make sure your browser has been granted permission to access the ${kind}.</div>
<img src="https://ezstack-source-1es5yaoqgtfar.s3.amazonaws.com/venue_398062/hFLUEcLgRh2NUgvi4eDS_1.png" alt="browser settings" style=" width: 100%; "/>
<ol class="list-decimal pl-5 mb-4" style="text-align: left;">
  <li>Click the lock/info icon in your browser's address bar</li>
  <li>Find the device permissions section</li>
  <li>Change the permission setting to "Allow"</li>
  <li>Refresh the page</li>
</ol>
        `;
    } else if (name === 'requesting') {
      title = 'Allow camera and microphone access';
      clazz = 'devices_permission_requesting_popup';
      msg = `
<div class="msg">Do you want people to see and hear you in the metting?</div>
<img src="https://ezstack-source-1es5yaoqgtfar.s3.amazonaws.com/venue_398062/We61aBUGTnGNywskgKUL_1.jpg" alt="permission requesting"/>
        `;
    }
    if (!['settings', 'requesting'].includes(name)) {
      return null;
    } else {
      const popup = SNModal.alert(msg, "OK", title, true, {
        backdrop: 'static',
        extra_class: ['devices_permission_popup', clazz]
      });
      popup.modal('show');
      return popup;
    }
  }
  const applyEffect = async (bg_type, bg_img, bg_blur = 6) => {
    console.log('MediaDevicesButtons applyEffect', bg_type, bg_img, window.effectsVideo_processor);
    if (!window.effectsVideo_processor) {
      return;
    }
    if (bg_type === 'none') {
      await window.effectsVideo_processor.clear();
    } else if (bg_type === 'blur') {
      await window.effectsVideo_processor.clear();
      await window.effectsVideo_processor.apply({
        blur: bg_blur / 10,
        background: {replace: ''},
        running: true
      });
    } else if (bg_type === 'image' && bg_img) {
      await window.effectsVideo_processor.clear();
      await window.effectsVideo_processor.apply({
        blur: 0,
        background: {replace: bg_img},
        running: true
      });
    }
  }

  return {
    init_devices: async function () {
      console.log('MediaDevicesButtons init_devices start');
      let devices = await navigator.mediaDevices.enumerateDevices();
      console.log('MediaDevicesButtons init_devices enumerateDevices', {devices});
      devices = devices.filter(device => device.deviceId && device.label);
      this.cameras = devices.filter(device => device.kind === DEVICE_KINDS.VIDEO);
      this.microphones = devices.filter(device => device.kind === DEVICE_KINDS.AUDIO);
      this.speakers = devices.filter(device => device.kind === DEVICE_KINDS.OUTPUT);
      this.current_camera_id = get_deviceId_from_storage(DEVICE_KINDS.VIDEO, this.cameras) ?? '';
      this.current_microphone_id = get_deviceId_from_storage(DEVICE_KINDS.AUDIO, this.microphones) ?? '';
      this.current_speaker_id = get_deviceId_from_storage(DEVICE_KINDS.OUTPUT, this.speakers) ?? '';
      console.log('MediaDevicesButtons init_devices done', {devices});
    },
    init_effects: async function () {
      const video_processor = tryget(() => Toolbox.snExpoLocation.current.current_content.settings.data.video_processor, 'effects') || 'effects';
      const customer_id = tryget(() => Toolbox.snExpoLocation.current.current_content.settings.data.effects_customer_id, '') || '';
      console.log('MediaDevicesButtons init_effects', {video_processor, customer_id});
      let is_supported = false;
      if (video_processor === 'effects' && customer_id && !window.effectsVideo_processor) {
        const effectsVideo_processor = new EZComponents.EffectsVideoProcessor(customer_id);
        is_supported = effectsVideo_processor.isSupported();
        console.log('EffectsSDK isSupported', is_supported);
        if (is_supported) {
          await effectsVideo_processor.init();
          window.effectsVideo_processor = effectsVideo_processor;
          await applyEffect(this.video_bg_type, Alpine.raw(this.video_bg_img), Alpine.raw(this.video_bg_blur));
        }
      }
    },
    _init: async function () {
      this.$el.innerHTML = templateHTML;

      const {camera: camera_permission, microphone: microphone_permission} = await check_device_permission();
      const constraints = {
        video: camera_permission?.state === 'prompt',
        audio: microphone_permission?.state === 'prompt'
      };
      // workaround for firefox
      // see https://engagez.atlassian.net/browse/EWA-6516?focusedCommentId=25385
      if (Toolbox.util.Sys.firefox) {
        constraints.video = camera_permission?.state !== 'denied';
        constraints.audio = microphone_permission?.state !== 'denied';
      }
      console.log('MediaDevicesButtons init', {camera_permission, microphone_permission, constraints});
      if (constraints.video || constraints.audio) {
        try {
          await request_device_permission(constraints);
        } catch (e) {
          console.error(e);
        }
        console.log('MediaDevicesButtons request_device_permission2', constraints);
      }
      // workaround for firefox.
      // we don't know why, but firefox return an empty devices array if you call navigator.mediaDevices.enumerateDevices() too soon.
      // luckly, this issue only when you call in first time.
      if (Toolbox.util.Sys.firefox) {
        setTimeout(async () => {
          console.log('MediaDevicesButtons delay init_devices', constraints);
          await this.init_devices();
        }, 1800);
      } else {
        await this.init_devices();
      }
      const is_camera_on = localStorage.getItem(`${storage_prefix}_video_dev_status`) === 'on';
      const is_microphone_on = localStorage.getItem(`${storage_prefix}_audio_dev_status`) === 'on';
      this.is_cancellation_on = (localStorage.getItem(`${storage_prefix}_noise_cancellation_status`) ?? 'on') === 'on';

      this.is_video_bg_supported = (Twilio?.VideoProcessors?.isSupported ?? true) && !(navigator.platform.match(/linux/i) && Toolbox.util.Sys.firefox);
      if (this.is_video_bg_supported) {
        const bg_settings = await Toolbox.snVideoCall?.getVideoBackground();
        this.video_bg_type = (bg_settings?.type ?? '') || 'none';
        this.video_bg_img = bg_settings?.image ?? '';
        this.video_bg_settings = bg_settings ?? null;
      }

      if (navigator.mediaDevices.ondevicechange === null) {
        addTrackedListener(navigator.mediaDevices, 'devicechange', async (e) => {
          console.log('MediaDevicesButtons ondevicechange', e);
          await this.init_devices();
        });
        // https://engagez.atlassian.net/browse/EWA-7244
        // https://issues.chromium.org/issues/364179206
        // the devicechange event is not fired when plugging in an audioinput device,
        // but we can work around it by calling of enumerateDevices() periodically.
        // setInterval(async () => {
        //   navigator.mediaDevices.enumerateDevices();
        // }, 5000);
      }
      const on_change = async (e) => {
        console.log('MediaDevicesButtons permission change', {e, camera_permission, microphone_permission});
        await this.init_devices();
        if (camera_permission.state === 'denied') {
          this.cameras = [];
        }
        if (microphone_permission.state === 'denied') {
          this.microphones = [];
          this.speakers = [];
        }
      };
      camera_permission.onchange = on_change;
      microphone_permission.onchange = on_change;

      eventListeners.push({target: camera_permission, type: 'onchange', listener: on_change, isProperty: true});
      eventListeners.push({target: microphone_permission, type: 'onchange', listener: on_change, isProperty: true});


      if (microphone_permission?.state === 'granted') {
        load_cancellation_models().then(() => {
          this.is_cancellation_model_loaded = true;
          if (this.is_cancellation_on && this.is_microphone_on) {
            SNModal.alert('Noise cancelation will be activated next time you unmute yourself.');
          }
        }).catch((e) => {
          console.warn(e);
        });
      }

      await this.$nextTick();

      addTrackedListener(document, EVENTS.DEVICE_STATUS_CHANGE, ev => {
        console.log('sn-change-device-status', ev);
        const {device, status} = ev.detail;
        if (device === 'camera' && status === 'on' !== this.is_camera_on) {
          document.querySelector('#cameraButton').dispatchEvent(new Event('click'));
        }
        if (device === 'microphone' && status === 'on' !== this.is_microphone_on) {
          document.querySelector('#microphoneButton').dispatchEvent(new Event('click'));
        }
      });

      addTrackedListener(document, EVENTS.VIDEO_BG_CHANGE, ev => {
        console.log('sn-change-video-bg', ev);
        const {type, img = ''} = ev.detail;
        this.onVideoBgItemClick(type, img);
      });

      addTrackedListener(document, EVENTS.SETTINGS_CHANGED, ev => {
        const settings = EZComponents.LiveMeetingSettingView.loadSettings();
        console.log('sn-live-meeting-settings', ev, settings);
        this.is_cancellation_on = settings?.bncEnabled ?? false;
        const selected_camera_id = settings?.selectedCameraDevice?.deviceId ?? '';
        if (selected_camera_id && selected_camera_id !== this.current_camera_id) {
          this.onCameraItemClick(selected_camera_id);
        }
        const selected_microphone_id = settings?.selectedMicDevice?.deviceId ?? '';
        if (selected_microphone_id && selected_microphone_id !== this.current_microphone_id) {
          this.onMicrophoneItemClick(selected_microphone_id);
        }
        const selected_speaker_id = settings?.selectedSpeakerDevice?.deviceId ?? '';
        if (selected_speaker_id && selected_speaker_id !== this.current_speaker_id) {
          this.onSpeakerItemClick(selected_speaker_id);
        }
        this.video_bg_blur = (settings?.blurPower ?? 0.5) * 10;
        const background_mode = settings?.backgroundMode ?? '';
        const background_img_url = settings?.selectedBackgroundImage ?? '';
        if (background_mode !== this.video_bg_type || background_img_url !== this.video_bg_img) {
          let img_url = '';
          if (background_mode === "image") {
            img_url = settings?.selectedBackgroundImage ?? Alpine.raw(this.video_bg_img);
          }
          this.onVideoBgItemClick(background_mode, img_url);
        }
      });

      const wait_for_localParticipant = async () => {
        await EzToolkit.RetryLib.retry(() => Promise.resolve(Toolbox?.snVideoCall?.activeRoom?.localParticipant), {
          retries: 10,
          delay: 500,
          until: (v) => v
        }).catch(e => console.error(e));
      }
      setTimeout(async () => {
        await this.$nextTick();
        const wait_local_participant = wait_for_localParticipant();
        const restore_camera = (async () => {
          if (!is_camera_on) {
            this.is_camera_restoring = false;
            return;
          }
          console.log('MediaDevicesButtons is_camera_on, turn on camera', {
            cameras: Alpine.raw(this.cameras),
            current_camera_id: this.current_camera_id
          });
          let waitings = [wait_local_participant];
          if (this.video_bg_type === "blur" || this.video_bg_type === "image") {
            waitings.push(this.init_effects());
          }
          try {
            await Promise.all(waitings);
            const is_camera_exist = this.cameras.find(x => x.deviceId === this.current_camera_id);
            if (is_camera_exist) {
              this.$el.querySelector('#cameraButton').dispatchEvent(new Event('click'));
            } else {
              this.is_camera_restoring = false;
            }
          } catch (e) {
            console.error(e);
            this.is_camera_restoring = false;
          }
        })();
        const restore_microphone = (async () => {
          if (!is_microphone_on) {
            this.is_microphone_restoring = false;
            return;
          }
          console.log('MediaDevicesButtons is_microphone_on, turn on microphone');
          const is_microphone_exist = this.microphones.find(x => x.deviceId === this.current_microphone_id);
          if (!is_microphone_exist) {
            this.is_microphone_restoring = false;
            return;
          }
          try {
            await wait_local_participant;
            this.$el.querySelector('#microphoneButton').dispatchEvent(new Event('click'));
          } catch (e) {
            console.error(e);
            this.is_microphone_restoring = false;
          }
        })();
        await Promise.all([restore_camera, restore_microphone]);
      }, 100);
      this.is_initialized = true;
      console.log('MediaDevicesButtons init done', {
        is_microphone_on: is_microphone_on,
        is_camera_on: is_camera_on,
        is_cancellation_on: this.is_cancellation_on,
        current_microphone_id: this.current_microphone_id,
        current_camera_id: this.current_camera_id,
        current_speaker_id: this.current_speaker_id,
        bg_type: this.video_bg_type,
      });
    },
    init: async function () {
      if (shouldSkipForBroadcast()) {
        return;
      }
      const meeting_panel = this.$el.closest('.group-meeting-panel');
      console.log('MediaDevicesButtons init', {meeting_panel, nid: this.nid});
      if (meeting_panel?.querySelector('.group-meeting-joined-wrapper .top-bar.hide')) {
        this.room_name = meeting_panel.querySelector('[data-room]')?.dataset['room'] ?? '';
        addTrackedListener(document, EVENTS.ROOM_VIEW_ATTACHED, async (e) => {
          console.log('SnVideoRoomViewAttached', e);
          const {nid, room} = e.detail;
          if (room === this.room_name) {
            await this._init();
          }
        });
        console.log('MediaDevicesButtons init2', "waiting for SnVideoRoomViewAttached event", {
          nid: this.nid,
          room_name: this.room_name
        });
        return;
      }
      try {
        await EzToolkit.RetryLib.retry(() => Promise.resolve(typeof Toolbox?.snVideoCall?.activeRoom?.localParticipant !== 'undefined'), RETRY_INFINITE);
        await this._init();
        await this.init_effects();

        await this.$nextTick();
        this.$watch('current_camera_id', (val) => {
          localStorage.setItem(`${storage_prefix}_video_dev`, val ?? '');
        });
        this.$watch('current_microphone_id', async (val, oldValue) => {
          console.log('MediaDevicesButtons current_microphone_id', val, oldValue);
          localStorage.setItem(`${storage_prefix}_audio_dev`, val ?? '');
          if (this.is_microphone_on && !this.microphones.some(d => d.deviceId === oldValue)) {
            // the old current_microphone_id is not in the microphones list,
            // it means the user has unplugged the microphone device. we need to republish the track with new device.
            this.turnOffMicrophone(false);
            await this.turnOnMicrophone(val, this.is_cancellation_on, false);
          }
        });
        this.$watch('current_speaker_id', (val) => {
          localStorage.setItem(`${storage_prefix}_speaker_dev`, val ?? '');
        });
        this.$watch('is_camera_on', (val) => {
          localStorage.setItem(`${storage_prefix}_video_dev_status`, val ? 'on' : 'off');
        });
        this.$watch('is_microphone_on', (val) => {
          localStorage.setItem(`${storage_prefix}_audio_dev_status`, val ? 'on' : 'off');
        });
        this.$watch('is_cancellation_on', (val) => {
          localStorage.setItem(`${storage_prefix}_noise_cancellation_status`, val ? 'on' : 'off');
        });
        this.$watch('cameras', (val) => {
          if (val?.length === 0) {
            this.turnOffCamera();
          }
        });
        this.$watch('microphones', (val) => {
          if (val?.length === 0) {
            this.turnOffMicrophone();
          }
        });
        this.$watch('video_bg_type', async (val, oldValue) => {
          console.log('watch video_bg_type', val, oldValue);
          await applyEffect(val, Alpine.raw(this.video_bg_img), Alpine.raw(this.video_bg_blur));
        });
        this.$watch('video_bg_img', async (val, oldValue) => {
          console.log('watch video_bg_img', `"${val}", "${oldValue}"`);
          if (val) {
            await applyEffect('image', Alpine.raw(val), Alpine.raw(this.video_bg_blur));
          }
        });
        this.$watch('video_bg_blur', async (val, oldValue) => {
          console.log('watch video_bg_blur', val, oldValue);
          await applyEffect('blur', '', val);
        });

        document.addEventListener("liveMeetingSettingViewAttached", (e) => {
          const status = e.detail?.status ?? '';
          if (status === "attached" && this.is_camera_on) {
            this.was_camera_on_before_settings = true;
            this.turnOffCamera();
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    destroy: function () {
      console.log('MediaDevicesButtons destroy');

      cleanupListeners();
      this._detachAudioMonitor();

      if (window.effectsVideo_processor) {
        window.effectsVideo_processor.clear();
        window.effectsVideo_processor = null;
      }

      if (this.is_camera_on) {
        this.turnOffCamera();
      }
      if (this.is_microphone_on) {
        this.turnOffMicrophone();
      }

      this.is_initialized = false;
    },
    nid: nid,
    room_name: '',
    is_initialized: false,
    is_camera_processing: false,
    is_microphone_processing: false,
    is_camera_restoring: true,
    is_microphone_restoring: true,
    is_camera_on: false,
    was_camera_on_before_settings: false,
    is_microphone_on: false,
    _audio_monitor: null,
    _audio_heal_timer: null,
    _audio_heal_retries: 0,
    is_cancellation_model_loaded: false,
    is_cancellation_on: false,
    cameras: [],
    microphones: [],
    speakers: [],
    current_camera_id: '',
    current_microphone_id: '',
    current_speaker_id: '',

    is_video_bg_supported: true,
    video_bg_type: 'none',
    video_bg_blur: 6,
    video_bg_img: '',
    video_bg_settings: null,

    get camera_tip() {
      if (this.cameras?.length === 0) {
        return 'You must allow camera access in your browser settings. Click for instructions.';
      }
      return this.is_camera_on ? 'Turn off Camera' : 'Turn on Camera';
    },
    get microphone_tip() {
      if (this.microphones?.length === 0) {
        return 'You must allow microphone access in your browser settings in order to unmute. Click for instructions.';
      }
      return this.is_microphone_on ? 'Mute Microphone' : 'Unmute Microphone';
    },

    createLocalVideoTrack: async function (deviceId, bg_type = '') {
      const videoTrackOptions = {
        width: {min: 640, ideal: 1280}, height: {min: 480, ideal: 720}
      };
      if (deviceId) {
        videoTrackOptions['deviceId'] = {exact: deviceId};
      }
      let track = null;
      try {
        track = await Twilio.Video.createLocalVideoTrack(videoTrackOptions);
        const processor = window.effectsVideo_processor;
        console.log('effectsVideo_processor', processor);
        if (processor) {
          track.addProcessor(processor, {inputFrameBufferType: 'videoframe'});
        }
      } catch (e) {
        console.error(e);
        throw e;
      }
      if (track === null) {
        return null;
      }
      if (bg_type && !window.effectsVideo_processor) {
        await Toolbox.snVideoCall.setVideoBackgroundProcessor(bg_type, 'vpbg-img', false, track);
      }
      return track;
    },
    publishTrack: async function (track) {
      const localParticipant = Toolbox?.snVideoCall?.activeRoom?.localParticipant;
      if (localParticipant === null) {
        return null;
      }
      return await localParticipant.publishTrack(track, {priority: 'standard'});
    },
    turnOffCamera: function (change_button_state = true) {
      const localParticipant = Toolbox?.snVideoCall?.activeRoom?.localParticipant;
      try {
        const track = Toolbox.snVideoCall._localVideoTrack;
        console.log('turnOffCamera', {localParticipant, track});
        if (track) {
          track.stop()
          // track.detach().forEach(ele => {
          //   ele.remove();
          // });
          Toolbox.snVideoCall._localVideoTrack = null;
          localParticipant.unpublishTrack(track);
          if (change_button_state) {
            this.is_camera_on = false;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    turnOnCamera: async function (deviceId, bg_type = '', change_button_state = true) {
      const track = await this.createLocalVideoTrack(deviceId, '');
      console.log('turnOnCamera', {track, bg_type});
      if (track === null) {
        return;
      }
      Toolbox.snVideoCall._localVideoTrack = track;
      const pub = await this.publishTrack(track);
      if (pub !== null) {
        if (change_button_state) {
          this.is_camera_on = true;
        }
        if (bg_type) {
          if (window.effectsVideo_processor) {
            await applyEffect(Alpine.raw(bg_type), Alpine.raw(this.video_bg_img), Alpine.raw(this.video_bg_blur))
          } else {
            await Toolbox.snVideoCall.setVideoBackgroundProcessor(bg_type, 'vpbg-img');
          }
        }
      } else {
        track.stop();
        Toolbox.snVideoCall._localVideoTrack = null;
      }
      return pub;
    },
    turnOffMicrophone: function (change_button_state = true) {
      this._detachAudioMonitor();
      const localParticipant = Toolbox?.snVideoCall?.activeRoom?.localParticipant;
      const tracks = Array.from(localParticipant.audioTracks.values()).map(x => x.track).filter(x => !screenshare_track_names.includes(x.name) && !presentation_track_names.includes(x.name));
      if (tracks && tracks.length > 0) {
        tracks.forEach((track) => track.stop());
        localParticipant.unpublishTracks(tracks);
      }
      if (change_button_state) {
        this.is_microphone_on = false;
      }
    },
    turnOnMicrophone: async function (deviceId, isNoiseCancellationOn = true, change_button_state = true) {
      const audioTrackOptions = {};
      if (isNoiseCancellationOn && this.is_cancellation_model_loaded) {
        audioTrackOptions['noiseCancellationOptions'] = cancellationOptions;
      }
      if (deviceId) {
        audioTrackOptions['deviceId'] = {exact: deviceId};
      }
      const localParticipant = Toolbox?.snVideoCall?.activeRoom?.localParticipant;
      const track = await Twilio.Video.createLocalAudioTrack(audioTrackOptions);
      const noiseCancellation = track.noiseCancellation;
      if (noiseCancellation) {
        if (isNoiseCancellationOn) {
          noiseCancellation.enable();
        } else {
          noiseCancellation.disable();
        }
      }
      const pub = localParticipant.publishTrack(track);
      this._attachAudioMonitor(track);
      if (change_button_state) {
        this.is_microphone_on = true;
      }
      return pub;
    },
    _detachAudioMonitor: function () {
      if (this._audio_heal_timer) {
        clearTimeout(this._audio_heal_timer);
        this._audio_heal_timer = null;
      }
      if (this._audio_monitor) {
        this._audio_monitor.listeners.forEach(({type, listener}) => {
          this._audio_monitor.source.removeEventListener(type, listener);
        });
        this._audio_monitor = null;
      }
    },
    _attachAudioMonitor: function (track) {
      this._detachAudioMonitor();
      const source = track?.noiseCancellation?.sourceTrack ?? track?.mediaStreamTrack;
      if (!source) {
        return;
      }
      const onMuted = () => {
        console.log('MediaDevicesButtons audio source muted', {readyState: source.readyState});
        if (this._audio_heal_timer) {
          return;
        }
        this._audio_heal_timer = setTimeout(() => {
          this._audio_heal_timer = null;
          this._healMicrophone('mute-timeout');
        }, AUDIO_TRACK_HEAL.MUTE_TIMEOUT_MS);
      };
      const onUnmuted = () => {
        console.log('MediaDevicesButtons audio source unmuted');
        if (this._audio_heal_timer) {
          clearTimeout(this._audio_heal_timer);
          this._audio_heal_timer = null;
        }
        this._healMicrophone('unmuted', AUDIO_TRACK_HEAL.UNMUTE_REBUILD_DELAY_MS);
      };
      const onEnded = () => {
        console.log('MediaDevicesButtons audio source ended');
        this._healMicrophone('ended');
      };
      const listeners = [['mute', onMuted], ['unmute', onUnmuted], ['ended', onEnded]];
      listeners.forEach(([type, listener]) => source.addEventListener(type, listener));
      this._audio_monitor = {source, listeners};
      if (source.muted) {
        console.log('MediaDevicesButtons audio source is muted on attach, waiting for unmute');
      }
    },
    _healMicrophone: async function (reason, delay = 0) {
      console.log('MediaDevicesButtons _healMicrophone', {reason, delay, is_microphone_on: this.is_microphone_on});
      if (!this.is_initialized || !this.is_microphone_on) {
        this._audio_heal_retries = 0;
        this._detachAudioMonitor();
        return;
      }
      if (this.is_microphone_processing) {
        this._audio_heal_timer = setTimeout(() => this._healMicrophone(reason), 2000);
        return;
      }
      await new Promise(resolve => setTimeout(resolve, delay));
      if (!this.is_microphone_on) {
        this._audio_heal_retries = 0;
        this._detachAudioMonitor();
        return;
      }
      if (this.is_microphone_processing) {
        this._audio_heal_timer = setTimeout(() => this._healMicrophone(reason), 2000);
        return;
      }
      this.is_microphone_processing = true;
      try {
        this.turnOffMicrophone(false);
        await this.turnOnMicrophone(this.current_microphone_id, this.is_cancellation_on, false);
        this._audio_heal_retries = 0;
        Toolbox.snVideoCall.av_buttons_status.microphone = "on";
      } catch (e) {
        console.error(e);
        this._audio_heal_retries++;
        if (this._audio_heal_retries < 2) {
          this._audio_heal_timer = setTimeout(() => this._healMicrophone(`retry-${reason}`), AUDIO_TRACK_HEAL.RETRY_DELAY_MS);
        } else {
          this.turnOffMicrophone();
          SNModal.alert(ERROR_MESSAGES.MICROPHONE_UNAVAILABLE);
          this._audio_heal_retries = 0;
        }
      } finally {
        this.is_microphone_processing = false;
      }
    },
    updateSpeakerDevice: function (deviceId) {
      try {
        document.querySelectorAll('.sn-video-room-view audio').forEach(x => {
          x.setSinkId(deviceId);
          x.play();
        });
      } catch (e) {
        console.error(e);
      }
    },

    onCameraItemClick: async function (deviceId) {
      tippy.hideAll({duration: 0});
      console.log('onCameraItemClick', {deviceId, is_camera_on: this.is_camera_on, video_bg_type: this.video_bg_type});
      let is_switch_track_success = true;
      if (this.is_camera_on) {
        try {
          this.turnOffCamera(false);
          await this.turnOnCamera(deviceId, this.video_bg_type, false);
        } catch (e) {
          console.error(e);
          SNModal.alert(camera_not_available_msg);
          is_switch_track_success = false;
        }
      }
      if (is_switch_track_success) {
        this.current_camera_id = deviceId;
      }
    },
    onMicrophoneItemClick: async function (deviceId) {
      tippy.hideAll({duration: 0});
      console.log('onMicrophoneItemClick', {deviceId});
      if (this.is_microphone_on) {
        this.turnOffMicrophone(false);
        await this.turnOnMicrophone(deviceId, this.is_cancellation_on, false);
      }
      this.current_microphone_id = deviceId;
    },
    onSpeakerItemClick: function (deviceId) {
      console.log('onSpeakerItemClick', {deviceId});
      tippy.hideAll({duration: 0});
      this.current_speaker_id = deviceId;
      this.updateSpeakerDevice(deviceId);
    },
    restore_video_bg_blur: function () {
      const settings = EZComponents.LiveMeetingSettingView.loadSettings();
      const blur_power = settings?.blurPower;
      if (typeof blur_power === 'number') {
        this.video_bg_blur = blur_power * 10;
      }
    },
    apply_onstage_bg_settings: async function () {
      let is_blur_handled = false;
      const apply_onstage = tryget(() => EZComponents.LiveMeetingSettingView.applyOnstageBgSettings, null);
      if (this.video_bg_settings && typeof apply_onstage === 'function') {
        try {
          const ret = apply_onstage(this.video_bg_settings);
          if (ret?.applied) {
            this.video_bg_type = ret.mode || 'none';
            this.video_bg_img = ret.selectedImage ?? '';
            if (typeof ret.blurPower === 'number') {
              this.video_bg_blur = ret.blurPower * 10;
              is_blur_handled = true;
            }
            if (this.video_bg_type === 'blur' || this.video_bg_type === 'image') {
              await this.init_effects();
            }
          }
        } catch (e) {
          console.error('apply_onstage_bg_settings', e);
        }
      }
      if (!is_blur_handled) {
        this.restore_video_bg_blur();
      }
    },
    onVideoBgItemClick: async function (type, url = '') {
      console.log('onVideoBgItemClick', {
        type,
        url,
        img_url: this.video_bg_img
      });
      tippy.hideAll({duration: 0});
      this.video_bg_type = type;
      this.video_bg_img = url;
      await post_video_bg_data(type, url);
      if (!window.effectsVideo_processor) {
        await Toolbox.snVideoCall.setVideoBackgroundProcessor(type, 'vpbg-img', false);
      }
    },
    prepareDeviceBtnClick: async function (kind) {
      let is_continue = true;
      if (!['camera', 'microphone'].includes(kind)) {
        return is_continue;
      }

      let {[kind]: {state}} = await check_device_permission(kind);
      console.log(`onButtonClick1`, kind, {permission: state});
      // we still need to request permission (call getUserMedia) at least once(means no cameras) even if we have permission 'granted' in Firefox
      let error = '';
      if (state === 'prompt' || (state !== 'denied' && Toolbox.util.Sys.firefox)) {
        const constraints = {video: kind === 'camera', audio: kind === 'microphone'};
        if (Toolbox.util.Sys.firefox) {
          if (kind === 'camera' && this.current_camera_id) {
            constraints.video = {
              deviceId: {exact: this.current_camera_id}
            }
          }
          if (kind === 'microphone' && this.current_microphone_id) {
            constraints.audio = {
              deviceId: {exact: this.current_microphone_id}
            }
          }
        }
        try {
          await request_device_permission(constraints);
        } catch (e) {
          error = e.name;
          if (error === 'NotAllowedError' && e.message.includes('Permission dismissed')) {
            error = 'PermissionDismissed';
          }
          if (error === 'AbortError' && e.message.includes('videoinput failed')) {
            error = 'NotReadableError';
          }
          console.error(e, error, {name: e.name, msg: e.message});
        }
        if (error === '') {
          // wait for init_devices done which trigger by permission change.
          await new Promise(resolve => setTimeout(resolve, 500));
          await this.$nextTick();
        } else if (error === 'NotAllowedError') {
          state = 'denied';
        }
      }

      // init_devices may not be done in time in Firefox, we have to do it again
      let is_no_devices = ((kind === 'camera' && this.cameras?.length === 0)
        || (kind === 'microphone' && this.microphones?.length === 0));
      if (is_no_devices && error === '' && state !== 'denied' && Toolbox.util.Sys.firefox) {
        await this.init_devices();
        await this.$nextTick();
      }

      // check again after init_devices and $nextTick
      is_no_devices = ((kind === 'camera' && this.cameras?.length === 0)
        || (kind === 'microphone' && this.microphones?.length === 0));
      console.log(`onButtonClick2`, kind, {
        permission: {state},
        cameras: Alpine.raw(this.cameras),
        microphones: Alpine.raw(this.microphones)
      });
      if (is_no_devices || state === 'denied') {
        if (error !== 'PermissionDismissed' && error !== 'NotReadableError') {
          show_popup('settings', kind);
        }
        // if (state === 'denied') {
        //   if (kind === 'camera') {
        //     this.cameras = [];
        //   }
        //   if (kind === 'microphone') {
        //     this.microphones = [];
        //   }
        //   await this.$nextTick();
        // }

        is_continue = error === 'NotReadableError';
      }
      return is_continue;
    },
    onCameraBtnClick: async function (event) {
      if (!this.is_initialized || this.is_camera_processing) {
        return;
      }
      if (this.is_camera_restoring && event?.isTrusted) {
        return;
      }

      if (!this.is_camera_on) {
        const is_continue = await this.prepareDeviceBtnClick('camera');
        if (!is_continue) {
          return;
        }
        await this.apply_onstage_bg_settings();
      }

      this.is_camera_processing = true;

      try {
        if (this.is_camera_on) {
          this.turnOffCamera();
        } else {
          await this.turnOnCamera(this.current_camera_id, this.video_bg_type);
        }
        Toolbox.snVideoCall.av_buttons_status.camera = this.is_camera_on ? "on" : "off";
      } catch (e) {
        console.error(e);
        SNModal.alert(camera_not_available_msg);
      } finally {
        this.is_camera_processing = false;
        this.is_camera_restoring = false;
      }
    },
    onMicrophoneBtnClick: async function (event) {
      if (!this.is_initialized || this.is_microphone_processing) {
        return;
      }
      if (this.is_microphone_restoring && event?.isTrusted) {
        return;
      }

      if (!this.is_microphone_on) {
        const is_continue = await this.prepareDeviceBtnClick('microphone');
        if (!is_continue) {
          return;
        }
      }

      this.is_microphone_processing = true;

      try {
        if (this.is_microphone_on) {
          this.turnOffMicrophone();
        } else {
          await this.turnOnMicrophone(this.current_microphone_id, this.is_cancellation_on);
        }
        Toolbox.snVideoCall.av_buttons_status.microphone = this.is_microphone_on ? "on" : "off";
      } catch (e) {
        console.error(e);
        SNModal.alert(ERROR_MESSAGES.MICROPHONE_UNAVAILABLE);
      } finally {
        this.is_microphone_processing = false;
        this.is_microphone_restoring = false;
      }
    },
    onSettingsClick: function (active_tab) {
      const container_ele = this.$el.closest('[x-data]');
      const ajaxSettings = {
        title: `Audio & Video Settings`,
        can_resize: true,
        can_close: true,
        'addition_settings': {
          'resize_min_width': 500,
          'resize_min_height': 400,
          // 'restore_user_size': true,
        },
      };
      const settings = {
        ajax: Promise.resolve(ajaxSettings),
        reset: false,
        box: 'sn-live-meeting-setting-panel-popup',
        can_close: true,
        can_resize: true,
        modalUI: true,
        trigger: null,
        parentid: 'body',
        'class': 'sc-session-popup sn-overlay-popup no-scale',
        title: `Audio & Video Settings`,
        content: `<div class="live-meeting-setting-panel-container"></div>`,
        boxConfig: {
          width: '700px',
          height: '440px',
          // left: `600px`,
          // top: `60px`,
          backgroundColor: '#d2dced'
        },
        boxConfigOpened: {width: '701px', height: '420px'},
        resize_direction: 'se',
        show_success_callback: () => {
          const panel = $jq('#sn-live-meeting-setting-panel-popup');
          if (panel.length === 0) {
            return;
          }
          // panel.css('left', `${left + 270}px`).css('top', `${top + 5}px`);
          // panel.find(".expo-panel-title").html('PRODUCER STUDIO');
          panel.find('.rightBottomBtn.top').remove();
          const container = panel.find('.live-meeting-setting-panel-container');
          if (container.length > 0) {
            const containerEle = container[0];
            const hh = panel[0]?.querySelector('.expo-panel-head')?.clientHeight ?? 42;
            panel[0]?.querySelector('.expo-panel-content')?.style.setProperty('--panel-header-height', `${hh}px`);
            containerEle.style.setProperty('--panel-z-index', Toolbox.snExpoPanel.PANEL_MAX_ZINDEX++);
            if (!(this._component_view ?? false)) {
              const content_id = Toolbox.snExpoLocation.current.current_content.content_id;
              const video_processor = tryget(() => Toolbox.snExpoLocation.current.current_content.settings.data.video_processor, 'twilio') || 'twilio';
              const customer_id = tryget(() => Toolbox.snExpoLocation.current.current_content.settings.data.effects_customer_id, '') || '';
              const is_super_admin = tryget(() => Toolbox.snExpoLocation.current.current_content.settings.data.is_super_admin, false) || false;
              const processorPreference = video_processor === 'twilio' ? 'twilio' : 'effects-sdk';
              const options = {
                processorPreference: processorPreference,
                effectsSDKcustomerID: customer_id,
                baseUrl: _base_url(),
                isSuperAdmin: is_super_admin,
                activeTab: active_tab,
              }
              const view = new EZComponents.LiveMeetingSettingView(options);
              view.attach(containerEle).then(() => {
                this._component_view = view;
              });
            }
          }
        },
        beforeClose: (from = '') => {
          this._component_view?.detach();
          this._component_view = null;
          document.dispatchEvent(new CustomEvent('sn-live-meeting-settings-changed', {detail: {}}));
          if (this.was_camera_on_before_settings) {
            this.was_camera_on_before_settings = false;
            container_ele.querySelector('#cameraButton').dispatchEvent(new Event('click'));
          }
          return true;
        }
      };
      const panel = new Toolbox.snExpoPanel(settings);
    },
  }
};

export const ScreenshareButton = function (nid) {
  console.log('ScreenshareButton init', {nid});
  if (shouldSkipForBroadcast()) {
    return;
  }

  const eventListeners = [];
  const cleanupListeners = () => {
    eventListeners.forEach(({target, type, listener, options}) => {
      target.removeEventListener(type, listener, options);
    });
    eventListeners.length = 0;
  };
  const addTrackedListener = (target, type, listener, options = false) => {
    target.addEventListener(type, listener, options);
    eventListeners.push({target, type, listener, options});
  };

  return {
    async init() {
      if (Toolbox.util.browser.is_mobile_device || typeof navigator?.mediaDevices?.getDisplayMedia !== 'function') {
        this.$el.style.display = 'none';
        return;
      }
      const {type, presenter, status} = Toolbox.snVideoCall?.current_presentation_status ?? {};
      this.presenter = presenter;
      this.presentationType = type;
      this.isPresentationOn = status === 'started';
      this.room = this.$el.closest('.group-meeting-joined-wrapper')?.dataset?.room ?? '';
      this.$el.innerHTML = `
<a class="screenshareButton toolbarButton round-btn video-icon " data-container="fullscreenElement"
 :class="isScreenshareOn ? 'screenshareOff' : 'screenshareOn'" x-bind:title="tooltip"
 @click.prevent.stop.throttle="onClick"
 >
  <i class="action-icon-fa" :class="isScreenshareOn ? 'fa-solid fa-stop' : 'fa-light fa-display' "></i>
</a>
<i class="fa-duotone fa-solid fa-volume-xmark" x-show="!audioTrack && isScreenshareOn"></i>
`;
      addTrackedListener(document, EVENTS.PRESENTATION_CHANGED, (e) => {
        console.log('participants-presentation-changed', e);
        const {type, presenter, status} = e.detail;
        this.presenter = presenter;
        this.presentationType = type;
        if (['started', 'ended'].includes(status)) {
          this.isPresentationOn = status === 'started' && ['slides', 'video', 'screenshare', 'ppt'].includes(type);
          this.isScreenshareOn = status === 'started' && "screenshare" === type && presenter === Toolbox.twilio.current_user.toLowerCase();
        }
      });

      addTrackedListener(document, EVENTS.ROOM_VIEW_ATTACHED, (e) => {
        console.log('ScreenshareButton SnVideoRoomViewAttached', e);
        const {nid, room} = e.detail;
        if (nid === 0 || nid === this.nid || room === this.room) {
          this.is_initialized = true;
        }
      });
    },

    nid: nid,
    room: '',
    is_initialized: false,
    isProcessing: false,
    presenter: "",
    presentationType: "",
    isPresentationOn: false,
    isScreenshareOn: false,
    mediaStream: null,
    videoTrack: null,
    audioTrack: null,
    get tooltip() {
      const s = this.isScreenshareOn ? 'Stop' : 'Start';
      return `${s} sharing screen or application`;
    },

    stopScreenSharing: async function () {
      Toolbox.snVideoCall.screenshare_local_track?.stop();
      let ret = null;
      if (this.audioTrack) {
        this.audioTrack.stop();
        Toolbox.snVideoCall.activeRoom.localParticipant.unpublishTrack(this.audioTrack);
        this.audioTrack = null;
      }
      if (this.videoTrack) {
        this.videoTrack.stop();
        ret = Toolbox.snVideoCall.activeRoom.localParticipant.unpublishTrack(this.videoTrack);
        this.videoTrack = null;
      }
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }
      return ret;
    },
    startScreenSharing: async function () {
      let ret = null;
      if (!navigator.getDisplayMedia && !navigator.mediaDevices.getDisplayMedia) {
        throw new Error('Your browser does NOT supports getDisplayMedia API.');
      }
      const getDisplayOptions = {
        video: {
          height: 1080,
          width: 1920,
        },
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100
        }
      }
      const mediaStream = await navigator.mediaDevices.getDisplayMedia(getDisplayOptions);
      this.mediaStream = mediaStream;
      const videoTracks = mediaStream.getVideoTracks();
      if (videoTracks.length > 0) {
        const videoTrack = videoTracks[0];
        this.videoTrack = videoTrack;
        const localTrack = new Twilio.Video.LocalVideoTrack(videoTrack, {name: 'video-composer-presentation'});
        Toolbox.snVideoCall.screenshare_local_track = localTrack;
        localTrack.once('stopped', () => {
          // Handle "stopped" event.
          console.log('Screen Sharing Stopped');
          this.stopScreenSharing();
        });
        ret = Toolbox.snVideoCall.activeRoom.localParticipant.publishTrack(localTrack, {priority: 'high'});
      }
      const audioTracks = mediaStream.getAudioTracks();
      if (audioTracks.length > 0) {
        const audioTrack = audioTracks[0];
        this.audioTrack = audioTrack;
        const localTrack = new Twilio.Video.LocalAudioTrack(audioTrack, {name: 'audio-composer-presentation'});
        Toolbox.snVideoCall.activeRoom.localParticipant.publishTrack(localTrack, {priority: 'high'});
      }

      return ret;
    },
    async onClick() {
      console.log('sccccc1', this.isProcessing, this.is_initialized, Toolbox.snVideoCall?.activeRoom?.localParticipant);
      tippy.hideAll({duration: 0});
      close_action_menu(null, true);
      if (this.isProcessing || !this.is_initialized || !Toolbox.snVideoCall?.activeRoom?.localParticipant) {
        return;
      }
      this.isProcessing = true;

      if (this.isPresentationOn && !this.isScreenshareOn) {
        Toolbox.twilio.getUserInfo(this.presenter, _current_expoid(), (u) => {
          const msg = this.presenter === Toolbox.twilio.current_user.toLowerCase() ?
            'You are currently sharing your presentation. Please stop the presentation before sharing your screen.'
            : `${u.fullname} is currently sharing. Please wait until the user has stopped sharing before attempting to share.`;
          SNModal.alert(msg);
        });
        this.isProcessing = false;
        return false;
      }

      if (this.isScreenshareOn) {
        try {
          await this.stopScreenSharing();
        } catch (e) {
          console.error(e);
        } finally {
          this.isProcessing = false;
        }
        if (typeof Toolbox.snVideoCall == 'object') {
          Toolbox.snVideoCall.toggleSlideDeck(true);
          Toolbox.snVideoCall.enableDisabledLayout();
        }
        this.isScreenshareOn = false;
      } else {
        try {
          const v = await this.startScreenSharing()
          if (v) {
            Toolbox.snVideoCall.toggleSlideDeck(false);
            Toolbox.snVideoCall.enableDisabledLayout();
            this.isScreenshareOn = true;
          }
        } catch (e) {
          console.error(e);
          if (e.name === 'NotAllowedError') {
            SNModal.alert('Your operating system prevented you from sharing your screen. Review your privacy settings for your operating system and try again.');
          } else {
            SNModal.alert(e.message);
          }
          if (this.videoTrack) {
            this.videoTrack.stop();
            this.videoTrack = null;
          }
          if (this.audioTrack) {
            this.audioTrack.stop();
            this.audioTrack = null;
          }
        } finally {
          this.isProcessing = false;
        }
      }

      this.isProcessing = false;
    },
    destroy: function () {
      console.log('ScreenshareButton destroy');

      cleanupListeners();

      if (this.isScreenshareOn) {
        this.stopScreenSharing().catch(e => console.warn('Error stopping screen sharing:', e));
      }

      if (this.videoTrack) {
        this.videoTrack.stop();
        this.videoTrack = null;
      }
      if (this.audioTrack) {
        this.audioTrack.stop();
        this.audioTrack = null;
      }
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
        this.mediaStream = null;
      }

      this.is_initialized = false;
    }
  }
};

export const LayoutSwitchButton = function (nid, enable_spotlight = true, enable_push = false) {
  console.log('LayoutSwitchButton init', {nid, enable_spotlight, enable_push});
  if (shouldSkipForBroadcast()) {
    return;
  }

  const eventListeners = [];
  const syncStateUnsubscribers = [];
  const cleanupListeners = () => {
    eventListeners.forEach(({target, type, listener, options}) => {
      target.removeEventListener(type, listener, options);
    });
    eventListeners.length = 0;
    syncStateUnsubscribers.forEach(unsub => unsub());
    syncStateUnsubscribers.length = 0;
  };
  const addTrackedListener = (target, type, listener, options = false) => {
    target.addEventListener(type, listener, options);
    eventListeners.push({target, type, listener, options});
  };

  let layouts = ['presentation', 'activespeaker', 'grid'];
  if (enable_spotlight) {
    layouts = ['presentation', 'spotlight', 'activespeaker', 'grid'];
  }
  const menu_texts = {
    "presentation": "Presentation View",
    "spotlight": "Spotlight View",
    "activespeaker": "Active Speaker View",
    "grid": "Grid View",
  };

  return {
    async _init() {
      const push_layout_key = `push_layout_key_${nid}_${Toolbox.snVideoCall.current_breakout_room_name}`;
      const unsubscribe = EzToolkit.SyncStateStore.subscribe(push_layout_key, (data) => {
        console.log('SyncStateStore.subscribe', {push_layout_key, data});
        const layout = data?.layout ?? 'grid';
        this.pushed_layout = layout;
        this.current_layout = layout;
        this.pushed_layout_on_srv = layout;
      }, {triggerImmediately: true});
      syncStateUnsubscribers.push(unsubscribe);
    },
    async init() {
      this.$el.innerHTML = `
<a x-ref="trigger_ele" class="toolbarButton video-icon round-btn" title="Control Layout" style="transform: none;">
    <i class="action-icon-fa fa-light fa-table-layout" aria-hidden="true"></i>
</a>
<ul x-ref="menu_ele" class="layout-switch-menu" role="menu">
<template x-for="(layout, index) in layouts">
  <li :class="{'current': layout === current_layout}" x-bind:data-layout="layout">
    <i class="fa-chisel fa-regular fa-check"></i>
    <a href="javascript:void(0)" class="switch" :class="{'disabled': isDisabled(layout)}" x-text="getLayoutText(layout)" x-on:click="onItemClick(layout)"></a>
    <a href="javascript:void(0)" class="push-layout" x-text="layout === pushed_layout? 'Pushed' : 'Push'" x-on:click="onPushLayoutClick(layout)"
      :class="{'pushed': layout === pushed_layout, 'disabled': isDisabled(layout), 'hide': isPushHidden(layout)}"
      :title="layout === current_layout? 'Current setting set for all attendees' : 'Push to set all attendees'">
    </a>
  </li>
</template>
</ul>
`;
      await this.$nextTick();
      const [trigger_ele, menu_ele] = [this.$refs['trigger_ele'], this.$refs['menu_ele']];
      tippy(trigger_ele, {
        trigger: "click",
        content: menu_ele,
        allowHTML: true,
        theme: 'tomato',
        interactive: true,
        placement: 'top',
        maxWidth: 'calc(80vw)',
        offset: [0, 20],
        zIndex: 9999999,
        onTrigger(instance, event) {
          instance.reference.style.transform = 'none';
        }
      });

      addTrackedListener(document, EVENTS.PRESENTATION_CHANGED, (e) => {
        const status = e.detail?.status ?? '';
        console.log('LayoutSwitchButton participants-presentation-changed', e.detail);
        if (status === 'started') {
          this.current_layout = 'presentation';
          this.pushed_layout = 'presentation';
        } else if (status === 'ended') {
          this.current_layout = this.pushed_layout_on_srv;
          this.pushed_layout = this.pushed_layout_on_srv;
        }
      });

      try {
        await EzToolkit.RetryLib.retry(() => Promise.resolve(typeof Toolbox?.snVideoCall?.current_breakout_room_name !== 'undefined'), RETRY_INFINITE);
        await this._init();
      } catch (e) {
        console.log(e);
      }
    },
    getLayoutText(layout) {
      return menu_texts[layout] ?? layout;
    },
    isDisabled(layout) {
      return layout === 'presentation' || this.pushed_layout === 'presentation';
    },
    isPushHidden(layout) {
      if (!enable_push) {
        return true;
      }
      if (layout === 'presentation') {
        return this.pushed_layout !== 'presentation';
      }
      return this.pushed_layout === 'presentation';
    },
    nid: nid,
    is_initialized: false,
    layouts: layouts,
    current_layout: 'grid',
    pushed_layout: 'grid',
    pushed_layout_on_srv: 'grid',

    onItemClick: function (layout) {
      if (this.isDisabled(layout) || this.current_layout === layout) {
        return;
      }
      Toolbox.snVideoCall.roomView && Toolbox.snVideoCall.roomView.setViewLayout(layout);
      this.current_layout = layout;
    },
    onPushLayoutClick: function (layout) {
      if (this.isDisabled(layout) || this.pushed_layout === layout) {
        return;
      }

      tippy.hideAll({duration: 0});

      const push_layout_key = `push_layout_key_${nid}_${Toolbox.snVideoCall.current_breakout_room_name}`;
      const popup_html = "<p>Are you sure you want to push this layout view? Once pushed, all participants' view setting will be changed to the PUSHED one.</p>";
      SNModal.confirm(popup_html, function () {
        EzToolkit.SyncStateStore.update(push_layout_key, (state) => {
          return Object.assign({_ttl: 315360000}, state, {layout, from: 'layout'});
        });
      }, $jq.noop, 'Push', 'Cancel', '', false, {extra_class: ['layout-push-confirm']});

      close_action_menu(null, true);
    },
    destroy: function () {
      console.log('LayoutSwitchButton destroy');

      cleanupListeners();

      const trigger_ele = this.$refs['trigger_ele'];
      if (trigger_ele && trigger_ele._tippy) {
        trigger_ele._tippy.destroy();
      }

      this.is_initialized = false;
    }
  }
};
